import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, XIcon } from 'lucide-react';
import Header from './components/Header';
import DNAHelix from './components/DNAHelix';
import ProjectSection from './components/ProjectSection';
import { AngledDivider } from './components/GeometricElements';
export function App() {
  const [isImpressumOpen, setIsImpressumOpen] = useState(false);
  const [isDatenschutzOpen, setIsDatenschutzOpen] = useState(false);
  // Platzhalter für Projekte
  const projects = [{
    id: 1,
    title: 'Digitale Produktionssteuerung mit Planungstool',
    description: 'Ziel des Projekts war die Entwicklung einer benutzerfreundlichen Softwarelösung zur Optimierung von Produktionsprozessen. Die Anwendung stellt eine zentrale Oberfläche bereit, über die Mitarbeitende schrittweise und gezielt durch ihre täglichen Aufgaben geführt werden. Der Fokus liegt auf einfacher Bedienung, klaren Arbeitsschritten und der Reduktion möglicher Eingabefehler.\n\nDie Anwendung kommuniziert über verschiedene Schnittstellen mit dem bestehenden ERP-System sowie weiteren Systemen wie einem Ticketsystem oder einem Dokumentationssystem. So können z. B. Arbeitsanweisungen automatisiert erstellt oder Störungen direkt als Ticket dokumentiert werden. Die Stammdatenverwaltung erfolgt zentral und synchronisiert sich automatisch mit den angeschlossenen Systemen.\n\nZur besseren Einsatzplanung wurde außerdem ein Modul zur Schichtplanung integriert, das neben der Planung von Arbeitszeiten auch Krankheitstage und Ausfälle abbilden kann.',
    client: 'Industrie GmbH',
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/f9EJL996oaZsVC8Y6h8rEp/Bildschirmfoto_2025-08-01_um_11.30.14.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ro8czUPhDxFyhvCpbdF7HX/Bildschirmfoto_2025-08-01_um_11.32.48.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/u1uZ4Jq3r4PyYPnsMnercr/Bildschirmfoto_2025-08-01_um_11.33.27.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ndT2BcPNsBn5SvCzcfE3VL/Bildschirmfoto_2025-08-01_um_11.33.55.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/vjabFWgB73RXHeRzHA8N8E/Bildschirmfoto_2025-08-01_um_11.34.31.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tWXdugAcvw8ybDakstACcs/Bildschirmfoto_2025-08-01_um_11.35.10.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/e9dyv3h9TkNLpyKg2LaSpJ/Bildschirmfoto_2025-08-01_um_11.35.51.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4k7NA3xssSn2tNkduMAJoN/Bild2.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hvve6FeoUvtfh96sVHSd4S/Bildschirmfoto_2025-08-01_um_12.57.01.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hKq9YfmkW9448ZVpTrV7bN/Bildschirmfoto_2025-08-01_um_12.57.11.png']
  }, {
    id: 2,
    title: 'Optimierte Netzauslastung durch smarte Energieverteilung',
    description: 'In diesem Projekt wurde eine Softwarelösung entwickelt, die verschiedene Energieverbraucher und Energieerzeuger wie Blockheizkraftwerke, Batteriespeicher und Photovoltaikanlagen intelligent miteinander vernetzt und steuert.\n\nZiel war es, den Energieverbrauch des Unternehmens zu jeder Jahreszeit wirtschaftlich zu optimieren. Dabei sollte die Wirkleistung am Netzanschlusspunkt möglichst konstant und effizient gehalten werden. Überschüssige Energie wird erst dann eingespeist oder verkauft, wenn alle Speicher geladen und notwendige Verbraucher versorgt sind. So lassen sich Zukäufe aus dem Netz minimieren oder Energie gezielt zu günstigen Zeiten verkaufen.\n\nDie größte Herausforderung bestand in der Anbindung und Steuerung unterschiedlichster Maschinen und Systeme innerhalb einer einheitlichen Plattform.',
    client: 'Vertrieb AG',
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/kXq3y5PsVGT97cw9rJmEfq/Bildschirmfoto_2025-08-01_um_12.57.01.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ggMEurmwuGDTSiaoYiqkLA/Bild2.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/masoRT9xzH7wUmgjhMnoZb/Bildschirmfoto_2025-08-01_um_12.57.11.png']
  }, {
    id: 3,
    title: 'Zuverlässige Maschinendatenerfassung für Langzeitanalysen',
    description: 'Im Rahmen dieses Projekts wurde eine Software entwickelt, die große Datenmengen aus verschiedenen Maschinen und Sensoren performant und zuverlässig über einen unbegrenzten Zeitraum erfasst.\n\nZiel war es, Verbrauchsdaten wie Strom, Reinigungsmittel sowie anfallende Abfälle und Rückstände präzise zu dokumentieren. Diese Daten bilden die Grundlage für fundierte Analysen zur Prozessoptimierung und zur Reduktion von Abfallmengen – etwa durch verbesserte Reinigung von Kundenbehältern oder effizientere Nutzung von Ressourcen.\n\nEin weiterer Schwerpunkt lag auf der Erfassung von Prozesszeiten je Produktionsschritt, insbesondere bei der Fassbearbeitung. So können Maschinen miteinander verglichen und Auslastung, Störungsraten und Engpässe besser identifiziert und optimiert werden.',
    client: 'Bau & Architektur GmbH',
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/43h9UHKpPSMVd2aEkg2CT4/Bildschirmfoto_2025-08-01_um_13.40.58.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/s1AjjoBbZN6fR47yWGtyVu/Bildschirmfoto_2025-08-01_um_13.40.31.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qEhJh4e9wTsJpTjaUur35S/Bildschirmfoto_2025-08-01_um_13.40.58.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4PdypuBNf2vByttEYjPK9X/Bildschirmfoto_2025-08-01_um_13.41.10.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/b6SvVVZtihPXpWfRRrRgfL/Bildschirmfoto_2025-08-01_um_13.41.36.png']
  }, {
    id: 4,
    title: 'Chargenrückverfolgung und stabile Produktionsprozesse',
    description: 'Für dieses Projekt wurde eine Softwarelösung entwickelt, die Produktionsprozesse deutlich robuster und weniger fehleranfällig gestaltet. Ein zentrales Ziel war die zuverlässige Chargenrückverfolgung über alle Produktionsschritte hinweg.\n\nDie Lösung besteht aus zwei Komponenten: einer App für den Produktionseinsatz, die unter anderem Barcodes scannt und Arbeitsschritte unterstützt, sowie einer Office-Anwendung zur Überwachung des Produktionsfortschritts und zur Verwaltung der Rückverfolgungsdaten.\n\nEine besondere Herausforderung lag in der Integration verschiedener Fremdsysteme zur Datenübergabe. Zusätzlich wurde die Kommunikation mit Scannern und einer Waage realisiert, um eine automatische Verwiegefunktion mit Plausibilitätsprüfung zu ermöglichen.',
    client: 'Online Handel KG',
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/7pg2fjGUviMdxsaTpYosmc/Bildschirmfoto_2025-08-01_um_14.11.43.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/azUg8zW8XMXp8PVt189eg9/Bildschirmfoto_2025-08-01_um_14.12.06.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tSZdjskW3MKMDiXbpRGZLq/Bildschirmfoto_2025-08-01_um_14.12.36.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hnvL8dh5CusJNrjbKB3SXa/Bildschirmfoto_2025-08-01_um_14.13.45.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nhMMkAEKbJDsgtJhvXucn7/Bildschirmfoto_2025-08-01_um_14.14.12.png']
  }, {
    id: 5,
    title: 'Abfüllsteuerung mit Wägedatenintegration und Prüfprotokoll',
    description: 'Für dieses Projekt wurde eine Software entwickelt, die den Abfüllprozess verschiedener Komponenten automatisiert steuert. Ein zentrales Element war die direkte Anbindung von Waagen zur Übertragung von Gewichten und Statusmeldungen in Echtzeit.\n\nEin weiterer Kernpunkt war die Durchführung von Probenmessungen, die direkt den jeweiligen Aufträgen zugeordnet werden. Die erfassten Messdaten werden automatisiert validiert und auf Einhaltung definierter Toleranzen geprüft.\n\nZur Auswertung und Nachverfolgung wurde zudem eine Exportfunktion realisiert, die die Daten im CSV- und Excel-Format bereitstellt. Diese können in einer übersichtlichen Excel-Ansicht angezeigt und analysiert werden.',
    client: 'Analyse & Strategie AG',
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/ucURyEWigSPxNcE7NMQgrg/Bildschirmfoto_2025-08-01_um_14.49.29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/cSf6R9w2qErLTfvEBYAMGa/Bildschirmfoto_2025-08-01_um_14.49.35.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/m1nc8BmszWYm5v3mr58ed1/Bildschirmfoto_2025-08-01_um_14.49.58.png']
  }];
  return <div className="bg-white min-h-screen" data-id="element-0">
      <Header data-id="element-1" />
      {/* DNA Helix Separator */}
      <DNAHelix data-id="element-2" />
      <div className="container mx-auto px-4" data-id="element-3">
        {projects.map((project, index) => <Fragment key={project.id} data-id="element-4">
            <ProjectSection project={project} isEven={index % 2 === 0} data-id="element-5" />
            {index < projects.length - 1 && <AngledDivider reversed={index % 2 !== 0} data-id="element-6" />}
          </Fragment>)}
      </div>
      <footer className="bg-[#284755] text-white py-10 mt-20 relative" data-id="element-7">
        <div className="container mx-auto px-4" data-id="element-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-9">
            <div className="mb-6 md:mb-0" data-id="element-10">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nGELzLwM8TMD7KS489WXvc/Logo.svg" alt="Intigoo Software Solutions" className="h-12" data-id="element-11" />
            </div>
            <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-12">
              <button onClick={() => setIsImpressumOpen(true)} className="text-white hover:underline font-medium" data-id="element-13">
                Impressum
              </button>
              <button onClick={() => setIsDatenschutzOpen(true)} className="text-white hover:underline font-medium" data-id="element-14">
                Datenschutz
              </button>
              <a href="mailto:info@intigoo.de" className="text-white hover:underline" data-id="element-15">
                Kontakt
              </a>
            </div>
          </div>
          <div className="border-t border-white/30 pt-6 text-center" data-id="element-16">
            <p data-id="element-17">© 2025 INTIGOO! GmbH. Alle Rechte vorbehalten.</p>
          </div>
        </div>
        {/* Impressum Modal */}
        {isImpressumOpen && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-18">
            <div className="bg-white text-gray-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative" data-id="element-19">
              <button onClick={() => setIsImpressumOpen(false)} className="absolute right-4 top-4 bg-gray-200 hover:bg-gray-300 rounded-full p-2 transition-colors" data-id="element-20">
                <XIcon size={20} data-id="element-21" />
              </button>
              <div className="p-6" data-id="element-22">
                <div className="mb-6" data-id="element-23">
                  <h2 className="text-2xl font-bold text-[#9CC31C] mb-4" data-id="element-24">
                    Impressum
                  </h2>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-25">
                    Angaben gemäß § 5 TMG
                  </p>
                </div>
                <div className="mb-6" data-id="element-26">
                  <p className="font-medium" data-id="element-27">INTIGOO! GmbH</p>
                  <p data-id="element-28">Werner-von-Siemens-Straße 33</p>
                  <p data-id="element-29">49124 Georgsmarienhütte</p>
                </div>
                <div className="mb-6" data-id="element-30">
                  <p data-id="element-31">
                    <span className="font-medium" data-id="element-32">Handelsregister:</span> HRB
                    217224
                  </p>
                  <p data-id="element-33">
                    <span className="font-medium" data-id="element-34">Registergericht:</span>{' '}
                    Amtsgericht Osnabrück
                  </p>
                </div>
                <div className="mb-6" data-id="element-35">
                  <p className="font-medium" data-id="element-36">Vertreten durch:</p>
                  <p data-id="element-37">Fabian Kleine Huxel</p>
                  <p data-id="element-38">Felix Höfelmeyer</p>
                </div>
                <div className="mb-6" data-id="element-39">
                  <h3 className="font-bold mb-2" data-id="element-40">Kontakt</h3>
                  <p data-id="element-41">
                    <span className="font-medium" data-id="element-42">Telefon:</span> +49 5401
                    1689580
                  </p>
                  <p data-id="element-43">
                    <span className="font-medium" data-id="element-44">E‑Mail:</span> info@intigoo.de
                  </p>
                </div>
                <div className="mb-6" data-id="element-45">
                  <h3 className="font-bold mb-2" data-id="element-46">Umsatzsteuer-ID</h3>
                  <p data-id="element-47">
                    Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                    Umsatzsteuergesetz:
                  </p>
                  <p data-id="element-48">DE 349819653</p>
                </div>
                <div className="mb-6" data-id="element-49">
                  <h3 className="font-bold mb-2" data-id="element-50">EU-Streitschlichtung</h3>
                  <p data-id="element-51">
                    Die Europäische Kommission stellt eine Plattform zur
                    Online-Streitbeilegung (OS) bereit:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-52">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    .
                  </p>
                  <p data-id="element-53">Unsere E‑Mail-Adresse finden Sie oben im Impressum.</p>
                </div>
                <div data-id="element-54">
                  <h3 className="font-bold mb-2" data-id="element-55">
                    Verbraucherstreitbeilegung / Universalschlichtungsstelle
                  </h3>
                  <p data-id="element-56">
                    Wir sind nicht bereit oder verpflichtet, an
                    Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
            </div>
          </div>}

        {/* Datenschutz Modal */}
        {isDatenschutzOpen && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-57">
            <div className="bg-white text-gray-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative" data-id="element-58">
              <button onClick={() => setIsDatenschutzOpen(false)} className="absolute right-4 top-4 bg-gray-200 hover:bg-gray-300 rounded-full p-2 transition-colors" data-id="element-59">
                <XIcon size={20} data-id="element-60" />
              </button>
              <div className="p-6" data-id="element-61">
                <div className="mb-6" data-id="element-62">
                  <h2 className="text-2xl font-bold text-[#9CC31C] mb-4" data-id="element-63">
                    Datenschutzerklärung
                  </h2>
                </div>

                <div className="mb-6" data-id="element-64">
                  <h3 className="font-bold mb-2" data-id="element-65">1. Verantwortlicher</h3>
                  <p data-id="element-66">
                    Die verantwortliche Stelle für die Datenverarbeitung auf
                    dieser Website ist:
                  </p>
                  <p className="mt-2 font-medium" data-id="element-67">INTIGOO! GmbH</p>
                  <p data-id="element-68">Werner-von-Siemens-Straße 33</p>
                  <p data-id="element-69">49124 Georgsmarienhütte</p>
                  <p className="mt-2" data-id="element-70">Telefon: +49 5401 4977 0</p>
                  <p data-id="element-71">E‑Mail: info@intigoo.de</p>
                  <p className="mt-2 text-sm text-gray-600" data-id="element-72">
                    Verantwortliche Stelle ist die natürliche oder juristische
                    Person, die allein oder gemeinsam mit anderen über die
                    Zwecke und Mittel der Verarbeitung von personenbezogenen
                    Daten (z. B. Namen, E‑Mail-Adressen o. Ä.) entscheidet.
                  </p>
                </div>

                <div className="mb-6" data-id="element-73">
                  <h3 className="font-bold mb-2" data-id="element-74">2. Hosting</h3>
                  <p data-id="element-75">
                    Diese Website wird bei Amazon Web Services (AWS) gehostet.
                  </p>
                  <p className="mt-2" data-id="element-76">Anbieter in Europa ist:</p>
                  <p className="font-medium" data-id="element-77">Amazon Web Services EMEA SARL</p>
                  <p data-id="element-78">38 Avenue John F. Kennedy</p>
                  <p data-id="element-79">L-1855 Luxemburg</p>
                  <p className="mt-2" data-id="element-80">
                    Beim Aufruf dieser Website werden durch den Hosting-Anbieter
                    automatisch folgende Daten verarbeitet:
                  </p>
                  <ul className="list-disc list-inside mt-2 mb-2 space-y-1" data-id="element-81">
                    <li data-id="element-82">IP-Adresse</li>
                    <li data-id="element-83">Datum und Uhrzeit des Zugriffs</li>
                    <li data-id="element-84">Browsertyp und Browserversion</li>
                    <li data-id="element-85">verwendetes Betriebssystem</li>
                    <li data-id="element-86">Referrer-URL</li>
                    <li data-id="element-87">Hostname des zugreifenden Rechners</li>
                  </ul>
                  <p data-id="element-88">
                    Diese Daten werden in sogenannten Server-Logfiles
                    gespeichert.
                  </p>
                  <p className="mt-2" data-id="element-89">
                    Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1
                    lit. f DSGVO (berechtigtes Interesse an der sicheren und
                    stabilen Bereitstellung der Website).
                  </p>
                  <p className="mt-2" data-id="element-90">
                    Mit AWS besteht ein Vertrag zur Auftragsverarbeitung gemäß
                    Art. 28 DSGVO.
                  </p>
                  <p className="mt-2" data-id="element-91">
                    Sofern eine Verarbeitung außerhalb der Europäischen Union
                    erfolgt, geschieht dies auf Grundlage geeigneter Garantien
                    gemäß Art. 44 ff. DSGVO (insbesondere
                    EU-Standardvertragsklauseln).
                  </p>
                </div>

                <div className="mb-6" data-id="element-92">
                  <h3 className="font-bold mb-2" data-id="element-93">3. Cookies</h3>
                  <p data-id="element-94">
                    Diese Website verwendet ausschließlich technisch notwendige
                    Cookies, soweit dies für den Betrieb erforderlich ist.
                  </p>
                  <p className="mt-2" data-id="element-95">
                    Es werden keine Analyse-, Tracking- oder Marketing-Cookies
                    eingesetzt.
                  </p>
                  <p className="mt-2" data-id="element-96">
                    Eine Einwilligung über ein Cookie-Banner ist daher nicht
                    erforderlich.
                  </p>
                </div>

                <div className="mb-6" data-id="element-97">
                  <h3 className="font-bold mb-2" data-id="element-98">4. Speicherdauer</h3>
                  <p data-id="element-99">
                    Server-Logfiles werden vom Hosting-Anbieter automatisch nach
                    einem angemessenen Zeitraum gelöscht.
                  </p>
                </div>

                <div className="mb-6" data-id="element-100">
                  <h3 className="font-bold mb-2" data-id="element-101">5. Ihre Rechte</h3>
                  <p data-id="element-102">Sie haben das Recht auf:</p>
                  <ul className="list-disc list-inside mt-2 mb-2 space-y-1" data-id="element-103">
                    <li data-id="element-104">Auskunft (Art. 15 DSGVO)</li>
                    <li data-id="element-105">Berichtigung (Art. 16 DSGVO)</li>
                    <li data-id="element-106">Löschung (Art. 17 DSGVO)</li>
                    <li data-id="element-107">Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                    <li data-id="element-108">Datenübertragbarkeit (Art. 20 DSGVO)</li>
                    <li data-id="element-109">Widerspruch (Art. 21 DSGVO)</li>
                  </ul>
                  <p className="mt-2" data-id="element-110">
                    Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an
                    die oben genannten Kontaktdaten.
                  </p>
                </div>

                <div className="mb-6" data-id="element-111">
                  <h3 className="font-bold mb-2" data-id="element-112">6. Beschwerderecht</h3>
                  <p data-id="element-113">
                    Sie haben das Recht, sich bei einer
                    Datenschutz-Aufsichtsbehörde zu beschweren.
                  </p>
                </div>
              </div>
            </div>
          </div>}
      </footer>
    </div>;
}